import { render, staticRenderFns } from "./UnionEdit.vue?vue&type=template&id=bf2e7ea6&scoped=true&"
import script from "./UnionEdit.vue?vue&type=script&lang=js&"
export * from "./UnionEdit.vue?vue&type=script&lang=js&"
import style0 from "./UnionEdit.vue?vue&type=style&index=0&id=bf2e7ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2e7ea6",
  null
  
)

export default component.exports